import { render, staticRenderFns } from "./hotel_offerings.vue?vue&type=template&id=62cbf7dd&"
import script from "./hotel_offerings.vue?vue&type=script&lang=js&"
export * from "./hotel_offerings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports